// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BuildersComponentsTrackingProvider } from '@gjensidige/builders-components';
import { TrackingProvider } from '@gjensidige/core-analytics';
import ErrorBoundary from '@gjensidige/service-error-boundary';
import tracker from './tracking';
import { App } from './App';
import './style.scss';

const rootElement = document.getElementsByClassName(
  'calculation-header-widget-root'
)[0];

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BuildersComponentsTrackingProvider options={tracker.options}>
          <TrackingProvider options={tracker.options}>
            <App />
          </TrackingProvider>
        </BuildersComponentsTrackingProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}